<form class="otp-plug position-relative" *ngIf="fieldStatus">
  <a href="javascript:void(0)" class="icon-close" (click)="onNoClick()"></a>
  <p class="font-bold text-center m-auto pb-3">
    {{ "OTP_VERIFICATION.MESSAGE" | translate }}
  </p>
  <ng-otp-input
    (onInputChange)="onOtpChange($event)"
    [config]="{ length: 4, allowNumbersOnly: true }"
  ></ng-otp-input>
  <div class="form-group d-flex align-items-center justify-content-center">
    <button
      [ngClass]="{ disabled: !btnDisable }"
      class="btn btn-theme btn-login"
      href="javascript:void(0)"
      (click)="onSubmit()"
    >
      <span class="spin icon-loader" *ngIf="isLoading"> </span>
      {{ "OTP_VERIFICATION.VERIFY" | translate }}
    </button>
    <div class="text-center para-color-gray">
      <!-- <a
        (click)="resendOTP()"
        href="javascript:void(0)"
        class="black-link pl-2 orange-link"
      >
        {{ "OTP_VERIFICATION.RESEND_OTP" | translate }}
      </a> -->
    </div>
  </div>
</form>
